import type { EndEvent } from 'jssip/lib/RTCSession';
import { Subject } from 'rxjs';

export class SipSessionOutgoingEventBus {
  static failed$ = new Subject<EndEvent>();
}
